import { PaymentPartnerType } from '../../../../../codegen/vehicles';
import { ServiceCardTypeIcon } from '../../../../../components/icons/ServiceCardTypeIcon';

export const PaceCardRepresentation = ({
  cardName,
  paymentPartner,
  expiryDate,
}: {
  cardName: string;
  paymentPartner: PaymentPartnerType;
  expiryDate: string;
}) => (
  <div className={'display-flex'}>
    <div>
      <ServiceCardTypeIcon
        type={paymentPartner}
        className="height-20 margin-right-10 margin-bottom-0"
      />
      <span>{cardName}</span>
    </div>

    <div className={'position-absolute right-0 margin-right-50'}>
      {expiryDate}
    </div>
  </div>
);
